import {Columns} from "./Columns";

export function getDynamicReportColumns(
    storageKey,
    storageData,
    props = {},
    fields = [],
) {
    const {
        getDynamicReportColumns = () => {},
    } = Columns[storageKey] || {};

    // currently only for profit & loss report
    return getDynamicReportColumns(storageKey, storageData, props, fields);
}
